module.exports = __webpack_public_path__ + "static/media/json.d27770c1.svg";